import React from "react";
import "./portfolio.css";
import PORTFOLIO1 from "../../assets/home construction-desktop.png";
import PORTFOLIO2 from "../../assets/miller-painting-painting.png";
import PORTFOLIO3 from "../../assets/kristy-zhang-desktop.png";
import PORTFOLIO4 from "../../assets/evergreen-landscaping-mobile.png";
import PORTFOLIO5 from "../../assets/home-cleaning-mobile.png";
import PORTFOLIO6 from "../../assets/grand-boulevard-mobile.png";
import PORTFOLIO7 from "../../assets/home-landscaping-desktop.png";
import PORTFOLIO8 from "../../assets/floralo-img-desktop.png";
import PORTFOLIO9 from "../../assets/solarcell-desktop.png";

const data = [
  {
    id: 1,
    image: PORTFOLIO1,
    title: "Home Construction",
    text: "Home Construction is a full-service construction company in Los Angeles, CA. They offer from custom kitchens to home expansions. ",
    github: "https://github.com",
    demo: "https://home-construction.netlify.app/",
  },
  {
    id: 2,
    image: PORTFOLIO2,
    title: "Miller Painting",
    text: "Miller Painting is a painter company located in Cleveland, Ohio.They offer residential and commercial interior and exterior house painting",
    github: "https://github.com",
    demo: "https://millerpainting.netlify.app/",
  },
  {
    id: 3,
    image: PORTFOLIO3,
    title: "Kristy Zhang",
    text: "Dr Kristy Zhang is a Naturopathic Doctor based in California who offers a holsitic approach to mental health.",
    github: "https://github.com",
    demo: "https://kristy-zhang.netlify.app/",
  },
  {
    id: 4,
    image: PORTFOLIO4,
    title: "Evergreen Landscaping",
    text: "Evergreen Landscaping is a landscaping company located in San Francisco, CA. They offer a wide range of landscaping services.",
    github: "https://github.com",
    demo: "https://evergreenlandscaping.netlify.app/",
  },
  {
    id: 5,
    image: PORTFOLIO5,
    title: "Home Cleaning",
    text: "Home Cleaning is a full-service cleaning company in Brooklyn,NY offering house cleaning, dog walking, groceries delivery.",
    github: "https://github.com",
    demo: "https://homecleaning.netlify.app/",
  },
  {
    id: 6,
    image: PORTFOLIO6,
    title: "Grand Boulevard",
    text: "Grand Boulevard is a restaurant located in Bronx, NY. They offer a private dining experience, private event and delicious food and wine.",
    github: "https://github.com",
    demo: "https://grand-boulevard.netlify.app/",
  },
  {
    id: 7,
    image: PORTFOLIO7,
    title: "Home Landscaping",
    text: "Home Landscaping is a full-service landscaping company located in Portland Oregon. They offer lawn maintenance, garden design.",
    github: "https://github.com",
    demo: "https://home-landscape.netlify.app/",
  },
  {
    id: 8,
    image: PORTFOLIO8,
    title: "Floralo Landscaping",
    text: "Floralo Landscaping is a full-service landscaping company in Denver, CO. They offer lawn maintenance, garden design, tree planting.",
    github: "https://github.com",
    demo: "https://floralo.netlify.app/",
  },
  {
    id: 9,
    image: PORTFOLIO9,
    title: "Solarcell Installs",
    text: "Solarcell is a Solar Panel company in Sacramento, CA and operating in 14 other states.They offer solar panel installs for your home.",
    github: "https://github.com",
    demo: "https://solar-cell.netlify.app/",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Projects</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo, text }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <p>{text}</p>
              <div className="portfolio__item-cta">
                {/* <a
                  href={github}
                  className="btn"
                  target="_blank"
                  rel="noreferrer"
                >
                  Github
                </a> */}
                <a
                  href={demo}
                  className="btn btn-primary btn-portfolio"
                  target="_blank"
                  rel="noreferrer"
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
